
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"18","cy":"18.811","r":"5.985"}}),_c('path',{attrs:{"d":"M31.68 18.81a13.72 13.72 0 00-.321-2.929L36 12.367l-3.42-5.924-5.375 2.268a13.649 13.649 0 00-5.063-2.94L21.42 0h-6.84l-.722 5.771a13.649 13.649 0 00-5.063 2.94L3.42 6.443 0 12.367l4.641 3.514a13.515 13.515 0 000 5.859L0 25.254l3.42 5.924 5.375-2.268a13.649 13.649 0 005.063 2.94l.722 5.771h6.84l.722-5.771a13.649 13.649 0 005.063-2.94l5.375 2.268L36 25.254l-4.641-3.514c.212-.962.32-1.944.321-2.93z"}})])])
          )
        }
      }
    